import React from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap';
import ServiceDesEight from '../ServiceContainer/ServiceDesEight';
import ServiceDesFive from '../ServiceContainer/ServiceDesFive';
import ServiceDesFour from '../ServiceContainer/ServiceDesFour';
import ServiceDesOne from '../ServiceContainer/ServiceDesOne';
import ServiceDesSeven from '../ServiceContainer/ServiceDesSeven';
import ServiceDesSix from '../ServiceContainer/ServiceDesSix';
import ServiceDesThree from '../ServiceContainer/ServiceDesThree';
import ServiceDesTwo from '../ServiceContainer/ServiceDesTwo';

function ServiceOne() {
    return (
        <div className="container  progress-container mb-5">
            {/* <div className="row row-cols-1 row-cols-lg-4 row-cols-md-2 row-cols-xs-1 g-2 g-lg-3 justify-content-center" >
                <div className="col" >
                    <h3 className="home-services-main-title">Our Services</h3>
                    <div className="row row-cols-1 row-cols-lg-4 row-cols-md-2 row-cols-xs-1 g-2 g-lg-3 justify-content-center" >
                        <div className='h-decor' ></div>
                    </div>
                </div>
            </div> */}
            <div className="row mt-4" style={{ justifyContent: 'center', marginRight: 0 }}>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                        <Col xl={3} md={4} sm={3} className="p-5">
                            <Nav variant="pills" className="flex-column">
                                <Nav.Item  >
                                    <Nav.Link className="serv_one_nav" eventKey="first">
                                        <h4 className='serv_one_nav_title'> Upper GI Tract Problems </h4>
                                        <div className='serv_line' ></div>
                                        {/* <p className="serv_one_nav_text"> The gradual accumulation of information about atomic and small-scale behaviour... </p> */}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item  >
                                    <Nav.Link className="serv_one_nav" eventKey="second">
                                        <h4 className='serv_one_nav_title'> Colorectal Problems </h4>
                                        <div className='serv_line' ></div>
                                        {/* <p className="serv_one_nav_text"> The gradual accumulation of information about atomic and small-scale behaviour... </p> */}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item  >
                                    <Nav.Link className="serv_one_nav" eventKey="third">
                                        <h4 className='serv_one_nav_title'> Abdominal Wall Problems </h4>
                                        <div className='serv_line' ></div>
                                        {/* <p className="serv_one_nav_text"> The gradual accumulation of information about atomic and small-scale behaviour... </p> */}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item  >
                                    <Nav.Link className="serv_one_nav" eventKey="four">
                                        <h4 className='serv_one_nav_title'> Retroperitoneum Problems </h4>
                                        <div className='serv_line' ></div>
                                        {/* <p className="serv_one_nav_text"> The gradual accumulation of information about atomic and small-scale behaviour... </p> */}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item  >
                                    <Nav.Link className="serv_one_nav" eventKey="five">
                                        <h4 className='serv_one_nav_title'> Liver Problems </h4>
                                        <div className='serv_line' ></div>
                                        {/* <p className="serv_one_nav_text"> The gradual accumulation of information about atomic and small-scale behaviour... </p> */}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item  >
                                    <Nav.Link className="serv_one_nav" eventKey="six">
                                        <h4 className='serv_one_nav_title'> Biliary System Problems </h4>
                                        <div className='serv_line' ></div>
                                        {/* <p className="serv_one_nav_text"> The gradual accumulation of information about atomic and small-scale behaviour... </p> */}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item  >
                                    <Nav.Link className="serv_one_nav" eventKey="seven">
                                        <h4 className='serv_one_nav_title'>Pancreas & Spleen Problems </h4>
                                        <div className='serv_line' ></div>
                                        {/* <p className="serv_one_nav_text"> The gradual accumulation of information about atomic and small-scale behaviour... </p> */}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item  >
                                    <Nav.Link className="serv_one_nav" eventKey="eight">
                                        <h4 className='serv_one_nav_title'> Laparoscopic Surgeries </h4>
                                        <div className='serv_line' ></div>
                                        {/* <p className="serv_one_nav_text"> The gradual accumulation of information about atomic and small-scale behaviour... </p> */}
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                        <Col xl={9} md={8} sm={9} className="mt-5">
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <ServiceDesOne />
                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    <ServiceDesTwo />
                                </Tab.Pane>
                                <Tab.Pane eventKey="third">
                                    <ServiceDesThree />
                                </Tab.Pane>
                                <Tab.Pane eventKey="four">
                                    <ServiceDesFour />
                                </Tab.Pane>
                                <Tab.Pane eventKey="five">
                                    <ServiceDesFive />
                                </Tab.Pane>
                                <Tab.Pane eventKey="six">
                                    <ServiceDesSix />
                                </Tab.Pane>
                                <Tab.Pane eventKey="seven">
                                    <ServiceDesSeven />
                                </Tab.Pane>
                                <Tab.Pane eventKey="eight">
                                    <ServiceDesEight />
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </div>
        </div>
    )
}

export default ServiceOne